import * as React from 'react';
import { SGBase, SGBaseProps, OptionalVector3, FillOptionalVector3, Vector3ToString, QuaternionToString } from './sgbase';
import { Vector3, TRSTransform, Quaternion, EulerToQuaternion, MultiplyVector3Scalar } from '../utils/transform';

export enum ETransformOrigin
{
	Seated,
	Standing,
	Raw,
}

export interface TransformProps extends SGBaseProps
{
	// If any of these three are specified, transform cannot be specified, vice-versa.
	translation?: OptionalVector3;
	rotation?: OptionalVector3; // euler degrees
	scale?: OptionalVector3 | number;

	transform?: TRSTransform;

	parent_path?: string;
	parent_origin?: ETransformOrigin;
	parent_id?: string;
}

declare global { namespace JSX {
	interface IntrinsicElements {
	  "vsg-transform": any;
	}
  }
}

export class Transform extends SGBase<TransformProps, null>
{
	constructor( props: any )
	{
		super( props );

		const numReparentingProps = (
			( props.parent_path === undefined ? 0 : 1 ) +
			( props.parent_origin === undefined ? 0 : 1 ) +
			( props.parent_id === undefined ? 0 : 1 )
		);
		if ( numReparentingProps > 1 )
		{
			throw new Error( "Transform cannot have more than one parent_ property set." );
		}
	}

	public internalRender()
	{
		let vTranslation: Vector3;
		let qRotation: Quaternion;
		let vScale: Vector3;

		if ( this.props.transform )
		{
			vTranslation = this.props.transform.translation;
			qRotation = this.props.transform.rotation;
			vScale = this.props.transform.scale;
		}
		else
		{
			vTranslation = FillOptionalVector3( this.props.translation, { x: 0, y: 0, z: 0 } );
			qRotation = EulerToQuaternion( MultiplyVector3Scalar( FillOptionalVector3( this.props.rotation, { x: 0, y: 0, z: 0 } ), Math.PI / 180 ) );
			if ( typeof this.props.scale === "number" )
			{
				vScale = { x: this.props.scale, y: this.props.scale, z: this.props.scale };
			}
			else
			{
				vScale = FillOptionalVector3( this.props.scale, { x: 1, y: 1, z: 1 } );
			}
		}

		let sTranslation = Vector3ToString( vTranslation );
		let sRotation = QuaternionToString( qRotation );
		let sScale = Vector3ToString( vScale );
		return (
			<vsg-transform
				translation={ sTranslation }
				rotation={ sRotation }
				scale={ sScale }
				parent-path={ this.props.parent_path }
				parent-origin={ ETransformOrigin[this.props.parent_origin] }
				parent-id={ this.props.parent_id }
				>
					{ this.props.children }
			</vsg-transform> );
	}
}

